import { FormItem } from '../../types/types';
import {
  FormMap,
  Group,
  Section,
} from '../../components/Manager/DatasetForm/types';

export const normalizeFormItemMap = (map: FormMap) => {
  const formItems: any[] = [];

  map.forEach((item: FormItem | Group | Section) => {
    if (item.type === 'section') {
      const normalizedSectionItem = {
        ...item,
        items: normalizeNestedItems(item.items),
      };
      formItems.push(normalizedSectionItem);
      return;
    }

    if (item.type === 'group') {
      const normalizedGroupItem = {
        ...item,
        items: normalizeNestedItems(item.items),
      };
      formItems.push(normalizedGroupItem);
      return;
    }

    formItems.push(item);
    return;
  });

  const groupedFormItems = groupSections(formItems);

  return groupedFormItems;
};

const groupSections = (formItems: any[]) => {
  const groupedFormItems: any[] = [];

  formItems.forEach((item) => {
    if (item.type === 'section') {
      const lastItemIndex = groupedFormItems.length - 1;

      if (Array.isArray(groupedFormItems[lastItemIndex])) {
        groupedFormItems[lastItemIndex].push(item);
        return;
      }

      groupedFormItems.push([item]);
      return;
    }

    groupedFormItems.push(item);
  });

  return groupedFormItems;
};

const normalizeNestedItems = (
  items: Map<string | number, FormItem | Group>
) => {
  const normalizedItems: any[] = [];
  items.forEach((item: FormItem | Group) => {
    if (item.type === 'group') {
      const normalizedGroupItem = {
        ...item,
        items: normalizeNestedItems(item.items),
      };
      normalizedItems.push(normalizedGroupItem);
    } else {
      normalizedItems.push(item);
    }
  });
  return normalizedItems;
};
